const DOMAIN_LETSTAY = 'letstay.co.il';
const DOMAIN_HTZ = 'htzone.arbitrip.com';
const DOMAIN_ELAL_TRAVEL = 'travel.elal.com';
const DOMAIN_ELAL_APPLICATION = 'application-elal.arbitrip.com';
const DOMAIN_STAGING = 'aws-staging.arbitrip.com';
const DOMAIN_ISRACARD = 'hotels.time-off.co.il';
const DOMAIN_AIRHAIFA_STAGING = 'airhaifa-staging.arbitrip.com';
const DOMAIN_AIRHAIFA = 'airhaifa.arbitrip.com';

module.exports = {
    DOMAIN_LETSTAY,
    DOMAIN_HTZ,
    DOMAIN_ELAL_TRAVEL,
    DOMAIN_ELAL_APPLICATION,
    DOMAIN_STAGING,
    DOMAIN_ISRACARD,
    DOMAIN_AIRHAIFA_STAGING,
    DOMAIN_AIRHAIFA,
};
